export default __webpack_public_path__ + "static/media/gke.fca6f426.svg";